import { DisabledOptions, DisabledReason } from '../hooks/useDisabledOptions'

export type ParseDisabledOptions =
  | DisabledOptions
  | (DisabledOptions | undefined)[]

/**
 * loops through the given {@link ParseDisabledOptions} and uses {@link parseReasons}
 * to construct a single string for tooltip content
 *
 * @param options
 */
export function parseDisabled(options?: ParseDisabledOptions) {
  const reasons = Array<DisabledReason>()
  if (Array.isArray(options)) {
    options.forEach((o) => {
      if (o?.disabled) reasons.push(o.reason)
    })
  } else if (options?.disabled) reasons.push(options.reason)
  return reasons.length ? parseReasons(reasons) : undefined
}

/**
 * parses {@link DisabledReason} objects into sentences, joining them with '. '
 * into one final string
 *
 * @param reasons
 */
function parseReasons(reasons: DisabledReason[]) {
  const segments = reasons.reduce((segments, reason) => {
    if (!reason) return segments
    if (reason === 'loading') segments.push('Loading..')
    else if (reason === 'missing permission')
      segments.push("You don't have permission to edit this field")
    else if (reason === 'no changes')
      segments.push('There are no unsaved changes')
    else if (reason.why === 'inactive')
      segments.push(
        `This field cannot be edited while its associated ${
          reason.entityName ?? 'record'
        } is inactive`
      )
    else if (reason.why === 'invalid status')
      segments.push(
        `This field cannot be edited while in status: ${reason.statusName}`
      )
    else if (reason.why === 'only status')
      segments.push(
        `This field can only be edited while in status: ${reason.statusName}`
      )
    else segments.push(reason.message)
    return segments
  }, Array<string>())
  return segments.join('. ') + '.'
}
